import * as React from 'react';
import '../css/link-buttons.sass';
import LinkButton from './LinkButton';

export interface LinkButtonType {
  name: string;
  id: string;
  children?: React.ReactNode;
  style?: React.CSSProperties;
  focus?: boolean;
  theme?: 'night' | 'day';
  onClick?: Function;
  disabled?: boolean;
  smol?: boolean;
  type?: 'primary' | 'secondary';
}

interface LinkButtonProps {
  linkButtons: LinkButtonType[];
}

export default function LinkButtons(props: LinkButtonProps) {
  const primaryLinkButton = props.linkButtons.filter(
    (btn: LinkButtonType) => btn.type === 'primary'
  )[0];
  const secondaryLinkButton = props.linkButtons.filter(
    (btn: LinkButtonType) => btn.type !== 'primary'
  )[0];
  return (
    <>
      {primaryLinkButton ? (
        <span
          className={
            props.linkButtons.length > 1 ? 'floating-primary-link' : ''
          }
        >
          <LinkButton
            {...primaryLinkButton}
            name={primaryLinkButton.name}
            id={primaryLinkButton.id}
            smol
            onClick={(e: any) => {
              if (primaryLinkButton.onClick !== undefined) {
                primaryLinkButton.onClick(e);
              }
            }}
          >
            {primaryLinkButton.children
              ? primaryLinkButton.children
              : primaryLinkButton.name}
          </LinkButton>
        </span>
      ) : null}
      {secondaryLinkButton ? (
        <span>
          <LinkButton
            {...secondaryLinkButton}
            name={secondaryLinkButton.name}
            id={secondaryLinkButton.id}
            smol
            type={secondaryLinkButton.type}
            onClick={(e: any) => {
              if (secondaryLinkButton.onClick !== undefined) {
                secondaryLinkButton.onClick(e);
              }
            }}
          >
            {secondaryLinkButton.children
              ? secondaryLinkButton.children
              : secondaryLinkButton.name}
          </LinkButton>
        </span>
      ) : null}
    </>
  );
}
